<template>
    <div class="mail-attachment-list" v-if="attachments && attachments.length > 0">
        <div v-for="(attachment, index) in attachments" :key="index" class="mail-attachment" style="display: flex">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind = "attrs"
                        v-on   = "on"
                        style  = "display: flex; width: 100%"
                    >
                        <p-dms-icon
                            :icon="icon(attachment)" style="margin-top: 2px; padding-right: 4px;" />
                        <div style=" overflow: hidden; white-space: nowrap; text-overflow: ellipsis; max-width: calc(100% - 25px)">{{ attachment.name }}</div>
                    </div>
                </template>

                <div style="display: flex">
                    <p-dms-icon
                        :icon="icon(attachment)"
                        style="margin-top: 2px; padding-right: 4px;"
                    />
                    <div>
                        {{ attachment.name }}
                    </div>
                </div>
            </v-tooltip>
        </div>
    </div>
</template>

<script>
import PDmsIcon from "@/modules/dms/viewer/private/PDmsIcon.vue";

export default {
    name: "PIncOutboxAttachments",

    props: {
        attachments: {

        }
    },

    components: {
        PDmsIcon
    },

    methods: {
        icon (attachment) {
            if (attachment.contentType === "application/pdf") {
                return "pdf"
            }

            return "file";
        }
    }
}
</script>

<style scoped>

.mail-attachment-list {
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    margin-top: 7px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 4px;
    width: calc(100% + 0px);
}

.mail-attachment {
    flex: 0 1 auto;
    padding: 4px;
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
    background-color: white;
    border-radius: 4px!important;
    width: calc(25% - 3px);
    max-width: calc(25% - 3px);
    height: 30px;
    padding-left: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-top: 0;
}

</style>